function fetchGeo() {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 300);
    const opts = { headers: { 'X-GEO-APP': 'ArkadiumAds' }, signal: controller.signal };
    return fetch('https://geoip.cdn.arkadiumhosted.com/json/', opts)
        .then(response => response.json())
        .finally(() => clearTimeout(timeout));
}
export function getGeo() {
    const w = window;
    w.__ark_ads__ = w.__ark_ads__ || {};
    w.__ark_ads__.geoPromise = w.__ark_ads__.geoPromise || fetchGeo();
    return w.__ark_ads__.geoPromise;
}
